export default "__VITE_ASSET__8UFNaXP9__"